var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0C7.23311 2.47606e-08 7.69231 0.459195 7.69231 1.02564V12.3077C7.69231 12.8741 7.23311 13.3333 6.66667 13.3333C6.10022 13.3333 5.64103 12.8741 5.64103 12.3077L5.64103 1.02564C5.64103 0.459196 6.10022 -2.47606e-08 6.66667 0Z",
    fill: "#5F6366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.66667C0 6.10022 0.459195 5.64103 1.02564 5.64103H12.3077C12.8741 5.64103 13.3333 6.10022 13.3333 6.66667C13.3333 7.23311 12.8741 7.69231 12.3077 7.69231H1.02564C0.459196 7.69231 0 7.23311 0 6.66667Z",
    fill: "#5F6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c735f33e1657349ad05fb6c397911503.svg";
export { ForwardRef as ReactComponent };